/**
 * Fuente única para la base HTTP del backend, origen WebSocket y URLs de recursos `/api/...`.
 *
 * - Define `REACT_APP_BACKEND_URL` en `.env` (p. ej. `https://api.tudominio.com`, sin barra final).
 * - En producción no hay respaldo a localhost; la variable debe fijarse en el build.
 * - En desarrollo: si no está definida, por defecto `http://localhost:8001`.
 *
 * Stripe: mantén claves de prueba en staging; la UI de producción puede seguir en modo test hasta que cambies.
 */
const raw = (process.env.REACT_APP_BACKEND_URL || '').trim().replace(/\/$/, '');
const isDev = process.env.NODE_ENV === 'development';
export const BACKEND_URL = raw || (isDev ? 'http://localhost:8001' : '');
export const API = BACKEND_URL ? `${BACKEND_URL}/api` : '';

/** Host `ws://` o `wss://` (sin ruta), derivado de `BACKEND_URL`. */
export function getBackendWsOrigin() {
  if (!BACKEND_URL) return '';
  return BACKEND_URL.replace(/^https:\/\//i, 'wss://').replace(/^http:\/\//i, 'ws://');
}

/**
 * URL absoluta para rutas guardadas como `/api/profile-image/...` (p. ej. `<img src>`).
 * Las rutas que no empiezan por `/api/` se devuelven igual (URLs externas, data URI, etc.).
 */
export function apiAssetUrl(path) {
  if (path == null || typeof path !== 'string') return path;
  if (!path.startsWith('/api/')) return path;
  return BACKEND_URL ? `${BACKEND_URL}${path}` : path;
}

if (typeof window !== 'undefined' && !BACKEND_URL) {
  // eslint-disable-next-line no-console
  console.warn(
    '[El Rincón] REACT_APP_BACKEND_URL no está definida. Los builds de producción la necesitan en tiempo de build.',
  );
}
